export function XeroSupportUploadAndResponseCtrl ($scope, $uibModalInstance, workshopAPI, result) {

  $scope.result = result ? result : {};

}